module.exports = __webpack_public_path__ + "img/37866-081.3069989e.jpg";